<template>
  <fragment>
    <div v-if="!authenticated || $route.meta.guest">
      <transition name="transition-routing" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <div class="app" v-if="authenticated  && !$route.meta.guest">

      <!-- Start Containerbar -->
      <div id="containerbar">
        <!-- Start Leftbar -->
        <div class="leftbar">
          <!-- Start Sidebar -->
          <div class="sidebar">
            <!-- Start Logobar -->
            <div class="logobar">
              <a href="index.html" class="logo logo-large">
                <img
                  src="assets/images/logo.svg"
                  class="img-fluid"
                  alt="logo"
                />
              </a>
              <a href="index.html" class="logo logo-small">
                <img
                  src="assets/images/small_logo.svg"
                  class="img-fluid"
                  alt="logo"
                />
              </a>
            </div>
            <!-- End Logobar -->
            <!-- Start Navigationbar -->
            <div class="navigationbar">
              <ul class="vertical-menu">
                <li>
                  <a href="javaScript:void();">
                    <img
                      src="assets/images/svg-icon/chart.svg"
                      class="img-fluid"
                      alt="dashboard"
                    />
                    <span>Dashboard</span>
                  </a>
                </li>
                <router-link tag="li" to="/company/list" exact>
                  <a href="#">
                    <img
                      src="assets/images/svg-icon/ecommerce.svg"
                      class="img-fluid"
                      alt="clienti"
                    />
                    <span>Clienti</span>
                  </a>
                </router-link>
               

                 <router-link tag="li" to="/macro/list" exact v-if="$store.getters.isInRole('macro-edit')">
                  <a href="#">
                    <img
                      src="assets/images/svg-icon/advanced.svg"
                      class="img-fluid"
                      alt="basic"
                    />
                    <span>Macro</span>
                  </a>
                </router-link>

                  <router-link tag="li" to="/newsletter/list" exact v-if="$store.getters.isInRole('newsletter-edit') || $store.getters.isInRole('newsletter-list')">
                  <a >
                    <img
                      src="assets/images/svg-icon/email.svg"
                      class="img-fluid"
                      alt="Comunicazioni"
                    />
                    <span>Comunicazioni</span>
                  </a>
                </router-link>
                 <router-link tag="li" to="/messagetemplate/list" exact v-if="$store.getters.isInRole('template-list') || $store.getters.isInRole('template-edit')">
                  <a href="#">
                    <img
                      src="assets/images/svg-icon/layouts.svg"
                      class="img-fluid"
                      alt="Modelli messaggi"
                    />
                    <span>Modelli Messaggi</span>
                  </a>
                </router-link>
                <li v-if="$store.getters.isInRole('tag-list') || $store.getters.isInRole('tag-edit') ||  $store.getters.isInRole('tagtype-list') ||  $store.getters.isInRole('tagtype-edit')">
                  <a class="cursor">
                    <img
                      src="assets/images/svg-icon/apps.svg"
                      class="img-fluid"
                      alt="advanced"
                    />
                    <span>Gestione Tags</span>
                    <i class="feather icon-chevron-right pull-right"></i>
                  </a>
                  <ul class="vertical-submenu">
                    <router-link tag="li" to="/tag/list" exact>
                      <a href="#">Tags</a>
                    </router-link>
                    <router-link tag="li" to="/tagtype/list" exact>
                      <a href="#">Tipologie</a>
                    </router-link>
                  </ul>
                </li>
                 <li v-if="$store.getters.isInRole('user-list') || $store.getters.isInRole('user-edit') ||  $store.getters.isInRole('profile-list') ||  $store.getters.isInRole('profile-edit')">
                  <a>
                    <img
                      src="assets/images/svg-icon/user.svg"
                      class="img-fluid"
                      alt="advanced"
                    />
                    <span>Gestione Utenti</span>
                    <i class="feather icon-chevron-right pull-right"></i>
                  </a>
                  <ul class="vertical-submenu">
                    <router-link tag="li" to="/utenti" exact v-if="$store.getters.isInRole('user-list') || $store.getters.isInRole('user-edit')">
                      <a href="#">Utenti</a>
                    </router-link>
                    <router-link tag="li" to="/profili" exact v-if="$store.getters.isInRole('profile-list') || $store.getters.isInRole('profile-edit')">
                      <a href="#">Profili</a>
                    </router-link>
                  </ul>
                </li>

                 <li  v-if="$store.getters.isInRole('stats-list') || $store.getters.isInRole('stats-import') || $store.getters.isInRole('stats-note')">
                  <a class="cursor">
                    <img
                      src="assets/images/svg-icon/chart.svg"
                      class="img-fluid"
                      alt="advanced"
                    />
                    <span>Statistiche Testate</span>
                    <i class="feather icon-chevron-right pull-right"></i>
                  </a>
                  <ul class="vertical-submenu">
                     <router-link tag="li" to="/kiosk/stats" exact v-if="$store.getters.isInRole('stats-list') || $store.getters.isInRole('stats-import') || $store.getters.isInRole('stats-note')">
                      <a href="#">Stats</a>
                    </router-link>
                     <router-link tag="li" to="/kiosk/notes" exact v-if="$store.getters.isInRole('stats-note')">
                      <a href="#">Note</a>
                    </router-link>
                    <router-link tag="li" to="/kiosk/import" exact v-if="$store.getters.isInRole('stats-import')">
                      <a href="#">Importa</a>
                    </router-link>
                   
                  </ul>
                </li>
              </ul>
            </div>
            <!-- End Navigationbar -->
          </div>
          <!-- End Sidebar -->
        </div>
        <!-- End Leftbar -->
        <!-- Start Rightbar -->
        <div class="rightbar">
          <!-- Start Topbar Mobile -->
          <div class="topbar-mobile">
            <div class="row align-items-center">
              <div class="col-md-12">
                <div class="mobile-logobar">
                  <a href="index.html" class="mobile-logo">
                    <img
                      src="assets/images/logo.svg"
                      class="img-fluid"
                      alt="logo"
                    />
                  </a>
                </div>
                <div class="mobile-togglebar">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <div class="topbar-toggle-icon">
                        <a
                          class="topbar-toggle-hamburger"
                          href="javascript:void();"
                        >
                          <img
                            src="assets/images/svg-icon/horizontal.svg"
                            class="img-fluid menu-hamburger-horizontal"
                            alt="horizontal"
                          />
                          <img
                            src="assets/images/svg-icon/verticle.svg"
                            class="img-fluid menu-hamburger-vertical"
                            alt="verticle"
                          />
                        </a>
                      </div>
                    </li>
                    <li class="list-inline-item">
                      <div class="menubar">
                        <a class="menu-hamburger" href="javascript:void();">
                          <img
                            src="assets/images/svg-icon/collapse.svg"
                            class="img-fluid menu-hamburger-collapse"
                            alt="collapse"
                          />
                          <img
                            src="assets/images/svg-icon/close.svg"
                            class="img-fluid menu-hamburger-close"
                            alt="close"
                          />
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Start Topbar -->
          <div class="topbar">
            <!-- Start row -->
            <div class="row align-items-center">
              <!-- Start col -->
              <div class="col-md-12 align-self-center">
                <div class="togglebar">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <div class="menubar">
                        <a class="menu-hamburger" href="javascript:void();">
                          <img
                            src="assets/images/svg-icon/collapse.svg"
                            class="img-fluid menu-hamburger-collapse"
                            alt="collapse"
                          />
                          <img
                            src="assets/images/svg-icon/close.svg"
                            class="img-fluid menu-hamburger-close"
                            alt="close"
                          />
                        </a>
                      </div>
                    </li>
                    <li class="list-inline-item">
                      <div class="searchbar d-none">
                        <form>
                          <div class="input-group">
                            <input
                              type="search"
                              class="form-control"
                              placeholder="Search"
                              aria-label="Search"
                              aria-describedby="button-addon2"
                            />
                            <div class="input-group-append">
                              <button
                                class="btn d-none"
                                type="submit"
                                id="button-addon2"
                              >
                                <img
                                  src="assets/images/svg-icon/search.svg"
                                  class="img-fluid"
                                  alt="search"
                                />
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>
                  </ul>
                </div>
                <infobar />
              </div>
              <!-- End col -->
            </div>
            <!-- End row -->
          </div>
          <!-- End Topbar -->
          <!-- Start Breadcrumbbar -->
          <breadcrumb />

          <!-- End Breadcrumbbar -->
          <!-- Start Contentbar -->
          <div class="contentbar">
            <transition name="transition-routing" mode="out-in">
              <router-view></router-view>
            </transition>
            <!-- Start row -->

            <!-- End row -->
          </div>
          <!-- End Contentbar -->
        </div>
        <!-- End Rightbar -->
      </div>
    </div>
   

    <app-footer v-if="authenticated && !$route.meta.guest"/>
  </fragment>
</template>
<style>
/* Import Font Awesome Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Font Awesome Icons Set */

@import "~font-awesome/css/font-awesome.min.css";
@import "~bootstrap/dist/css/bootstrap.css";

@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>
<style lang="scss">

.dataTables_length .custom-select{
width: 31% !important;

}
.cursor{
cursor: pointer;

}
// Import Main styles for this application
@import "./scss/style";
</style>
<script>
import AppLoader from "@/components/AppLoader.vue";
import AppInfoBar from "@/components/AppInfoBar.vue";
import axios from 'axios'
import { Breadcrumb, AppFooter } from "./components/";
export default {
  computed: {
    authenticated() {
      return this.$store.getters.isAuthenticated && !this.$store.state.user.expired;
    },
    operarators() {
      return this.$store.state.operarators;
    },
    cuser() {
      return this.$store.state.user;
    },
  },
  components: {
    AppLoader,
    infobar: AppInfoBar,
    /* AppHeader,
            Sidebar,
            AppAside,*/
    AppFooter,
    Breadcrumb,
  },

  mounted() {
    var me = this;

    $(document).on("click", ".edit-action", window.EditAction);
    $(document).on("click", ".remove-action", function(){
var url =$(this).data('url');
        me.$swal({
        title: ``,
        html: `Sicuri di eliminare la risorsa?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .delete(url)
            .then((response) => {
              me.$swal({
                title: "Cancellazione avvenuta con successo",
                text: "",
                type: "success",
                showCancelButton: false,
                toast: true,
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-top",
              });

             me.$router.go()
            });
        }
      });

    });

   $.sidebarMenu = function (menu) {
    console.log(menu);
    var animationSpeed = 300,
      subMenuSelector = ".vertical-submenu";
    $(document).on("click", ".vertical-menu li a", function (e) {
      var $this = $(this);
      var checkElement = $this.next();
      if (checkElement.is(subMenuSelector) && checkElement.is(":visible")) {
        checkElement.slideUp(animationSpeed, function () {
          checkElement.removeClass("menu-open");
        });
        checkElement.parent("li").removeClass("active");
      } else if (
        checkElement.is(subMenuSelector) &&
        !checkElement.is(":visible")
      ) {
        var parent = $this.parents("ul").first();
        var ul = parent.find("ul:visible").slideUp(animationSpeed);
        ul.removeClass("menu-open");
        var parent_li = $this.parent("li");
        checkElement.slideDown(animationSpeed, function () {
          checkElement.addClass("menu-open");
          parent.find("li.active").removeClass("active");
          parent_li.addClass("active");
        });
      }
      if (checkElement.is(subMenuSelector)) {
        e.preventDefault();
      }
      return false;
    });
  };

window.SetMenu = 
    function () {
      $(".vertical-menu a").removeClass("active");
      $(".vertical-menu li").removeClass("active");
      for (
        var a = window.location,
          abc = $(".vertical-menu a")
            .filter(function () {
              return this.href == a;
            })
            .addClass("active")
            .parent()
            .addClass("active");
        ;

      ) {
        if (!abc.is("li")) break;
        abc = abc.parent().addClass("in").parent().addClass("active");
      }
    }
    $(function(){window.SetMenu();
    function InitilizeMenu(){

$.sidebarMenu($(".vertical-menu"));
    }
    InitilizeMenu();
    });
   /* -- Infobar Setting Sidebar -- */
    $(document).on("click","#infobar-settings-open", function(e) {
        e.preventDefault();
        $(".infobar-settings-sidebar-overlay").css({"background": "rgba(0,0,0,0.4)", "position": "fixed"});
        $("#infobar-settings-sidebar").addClass("sidebarshow");
    }); 
    $(document).on("click","#infobar-settings-close", function(e) {
        e.preventDefault();
        $(".infobar-settings-sidebar-overlay").css({"background": "transparent", "position": "initial"});
        $("#infobar-settings-sidebar").removeClass("sidebarshow");
    });
    /* -- Menu Hamburger -- */
    $(document).on("click",".menu-hamburger", function (e) {
      e.preventDefault();
      $("body").toggleClass("toggle-menu");
      $(".menu-hamburger img").toggle();
    });
    /* -- Menu Topbar Hamburger -- */
    $(document).on("click",".topbar-toggle-hamburger", function (e) {
      e.preventDefault();
      $("body").toggleClass("topbar-toggle-menu");
      $(".topbar-toggle-hamburger img").toggle();
    });
    /* -- Menu Scrollbar -- */
    /*$('.vertical-menu').slimscroll({
        height: '700px',
        position: 'right',
        size: "7px",
        color: '#CFD8DC',
    });*/
    /* -- Media Size -- */
    function mediaSize() {
      if (window.matchMedia("(max-width: 767px)").matches) {
        $("body").removeClass("toggle-menu");
        $(".menu-hamburger img.menu-hamburger-close").hide();
        $(".menu-hamburger img.menu-hamburger-collapse").show();
      }
    }
    mediaSize();
    window.addEventListener("resize", mediaSize, false);

    /* -- Bootstrap Popover -- */
    $('[data-toggle="popover"]').popover();
    /* -- Bootstrap Tooltip -- */
    $('[data-toggle="tooltip"]').tooltip();
  },
};
</script>

